var _title, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgThunder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "weather-cloud-thunder")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.513,9.443a.252.252,0,0,1-.071-.218A4.6,4.6,0,0,0,22.5,8.5a4.491,4.491,0,0,0-3.517-4.393.248.248,0,0,1-.171-.136,7,7,0,0,0-12.988.916.251.251,0,0,1-.205.173,6.5,6.5,0,0,0,.294,12.914.25.25,0,0,0,.268-.205,2.319,2.319,0,0,1,.511-1.09l0,0,.218-.268A.249.249,0,0,0,6.72,16H6.5a4.5,4.5,0,1,1,.081-9h0a1,1,0,0,0,.986-.834,5,5,0,0,1,9.647-.831,1,1,0,0,0,.9.667,2.5,2.5,0,0,1,2.232,3.365,1,1,0,0,0,.366,1.169A3,3,0,0,1,19,16h-.958a.251.251,0,0,0-.244.3,2.338,2.338,0,0,1-.1,1.355.247.247,0,0,0,.027.231.25.25,0,0,0,.206.109H19a5,5,0,0,0,3.513-8.557Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.281,16.476A.826.826,0,0,0,15.536,16H14.25a.25.25,0,0,1-.25-.25V11.5a.5.5,0,0,0-.888-.316L7.839,17.645l0,0A.822.822,0,0,0,8.464,19H9.75a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.332.471A.487.487,0,0,0,10.5,24a.5.5,0,0,0,.388-.184l5.273-6.461,0,0A.826.826,0,0,0,16.281,16.476Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThunder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thunder.b52886ea.svg";
export { ForwardRef as ReactComponent };